import { CircularProgress } from "@mui/material";

import { LinearProgress } from "@mui/material";

import { Box } from "@mui/material";

import { Button } from "@mui/material";

import { Paper, Typography } from "@mui/material";

import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import { useRef } from 'react';

interface SubmitOptionsProps {
  mapDineroToEconomic: (dineroContacts: any[]) => void;
  dineroData: any[];
  economicData: any[];
  isSubmitting: boolean;
  handleSubmitMapping: () => void;
  handleStopSubmit: () => void;
  submissionReport: any;
  currentBatch: number;
  totalBatches: number;
  submitProgress: number;
  setShowReport: (show: boolean) => void;
  showButtonCustomerGroup?:boolean;
  isLoadingButtonCustomerGroup?:boolean;
  handleSubmitButtonCustomerGroup?: () => void;
  showButtonSupplierGroup?:boolean;
  handleSubmitButtonSupplierGroup?: () => void;
  isLoadingButtonSupplierGroup?:boolean;
}

const SubmitOptions = ({
  mapDineroToEconomic,
  dineroData,
  economicData,
  isSubmitting,
  handleSubmitMapping,
  handleStopSubmit,
  submissionReport,
  currentBatch,
  totalBatches,
  submitProgress,
  setShowReport,  
  showButtonCustomerGroup,
  isLoadingButtonCustomerGroup,
  handleSubmitButtonCustomerGroup,
  showButtonSupplierGroup,
  isLoadingButtonSupplierGroup,
  handleSubmitButtonSupplierGroup
}: SubmitOptionsProps) => {
    const isProcessingRef = useRef(false);

    const handleSubmit = () => {
        if (isProcessingRef.current) return;
        
        isProcessingRef.current = true;
        mapDineroToEconomic(dineroData);
        setTimeout(() => {
          handleSubmitMapping();
          isProcessingRef.current = false;
        }, 1000);
    }
  return (
    <Paper sx={{ 
        p: 2, 
        mb: 2, 
        position: 'sticky', 
        top: 178,
        zIndex: 1000, 
        backgroundColor: 'white',
        // boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <Typography variant="h6" gutterBottom>
          Submit Options
        </Typography>
        {/* <Box sx={{ display: 'flex', flexDirection: 'row', gap: 4, mb: 1 }}>
          <FormControlLabel
            control={
              <Switch
                checked={updateExistingCustomer}
                onChange={(e) => setUpdateExistingCustomer(e.target.checked)}
              />
            }
            label="Update existing customer"
          />
          {updateExistingCustomer && (
          <Box sx={{ mb: 2 , width: '200px'}}>
            <FormControl fullWidth size="small">
              <InputLabel>Key</InputLabel>
              <Select
                value={updateKey}
                label="Key"
                onChange={(e) => setUpdateKey(e.target.value)}
              >
                {dineroColumns.map((column) => (
                  <MenuItem key={column.id} value={column.id}>
                    {column.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
        </Box> */}
        
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
          {showButtonCustomerGroup && (
            <Button
              variant="outlined"
              onClick={handleSubmitButtonCustomerGroup}
              disabled={isLoadingButtonCustomerGroup}
            >
              {isLoadingButtonCustomerGroup ? <CircularProgress size={20} /> : "Generate Customer Group To e-conomic"}
            </Button>
          )}
          {showButtonSupplierGroup && (
            <Button
              variant="outlined"
              onClick={handleSubmitButtonSupplierGroup}
              disabled={isLoadingButtonSupplierGroup}
            >
              {isLoadingButtonSupplierGroup ? <CircularProgress size={20} /> : "Generate Supplier Group To e-conomic"}
            </Button>
          )}
          <Button
            variant="contained"
            onClick={() => mapDineroToEconomic(dineroData)}
            disabled={dineroData.length === 0 || isSubmitting}
          >
            Update data
          </Button>
          <Button
            variant="contained"
            color="warning"
            onClick={handleSubmit}
            disabled={economicData.length === 0 || isSubmitting || isProcessingRef.current}
          >
            Submit Data to E-conomic
          </Button>
          {isSubmitting && (
            <Button
              variant="contained"
              color="error"
              onClick={handleStopSubmit}
            >
              Stop
            </Button>
          )}
          {submissionReport && (
            <Button
              variant="outlined"
              onClick={() => setShowReport(true)}   
              startIcon={<FolderOpenIcon />}
            >
              View Report
            </Button>
          )}
          {isSubmitting && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="body2">
                Processing batch {currentBatch} of {totalBatches} (
                {submitProgress}%)
              </Typography>
              <CircularProgress size={20} />
              <LinearProgress variant="determinate" value={submitProgress} />
            </Box>
          )}
        </Box>
      </Paper>
  );
};

export default SubmitOptions;
